import { API_METHOD, NAMESPACE_API_PATH } from '~/app/shared/utils/consts/api';

const DEFAULT_QR_CODE_SIZE = 300;

export const SimaESignatureApi = $api => {
  $api.register('sima', NAMESPACE_API_PATH.PRIVATE, request => ({
    getSignLink() {
      return request(API_METHOD.GET, `/electronic-signature/link`);
    },

    getSignQrCode(size = DEFAULT_QR_CODE_SIZE) {
      return request(API_METHOD.GET, `/electronic-signature/qr-code?size=${size}`, {
        responseType: 'blob',
      });
    },

    setSignMethod(payload) {
      return request(API_METHOD.PUT, '/signing-method', payload);
    },

    checkSignStatus() {
      return request(API_METHOD.GET, '/electronic-signature/status');
    },

    startESignatureProcess(payload) {
      return request(API_METHOD.POST, '/electronic-signature/process/start', payload);
    },
  }));
};
